import { render, staticRenderFns } from "./ObjectInformation.vue?vue&type=template&id=cd8c3766&scoped=true"
import script from "./ObjectInformation.vue?vue&type=script&lang=js"
export * from "./ObjectInformation.vue?vue&type=script&lang=js"
import style0 from "./ObjectInformation.vue?vue&type=style&index=0&id=cd8c3766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd8c3766",
  null
  
)

export default component.exports